const ENDPOINT = new Map();
ENDPOINT.set('fetch', '/notification/get');
ENDPOINT.set('delete', '/notification/delete');
ENDPOINT.set('read', '/notification/read');
export default ENDPOINT
